import { RequestPutAnomaly } from '@api/twin/AnomalyApi';
import { datadogRum } from '@datadog/browser-rum';
import { zodResolver } from '@hookform/resolvers/zod';
import { Box } from '@stereograph/teia-system-design/components/Box';
import { usePluginTranslation } from '@translation';
import { FormProvider, useForm } from 'react-hook-form';
import { useAnomalySectionContext } from '../../context/AnomalySectionContext';
import { useAnomalyWidgetContext } from '../../context/AnomalyWidgetContext';
import { usePutAnomaly } from '../../hooks/usePutAnomaly';
import { AnomalyForm, AnomalyFormSchema, anomalyFormSchema } from './AnomalyForm';

export const UpdateAnomalyForm = () => {
  const { anomaly } = useAnomalySectionContext();
  const { projectId } = useAnomalyWidgetContext();
  const { putAnomaly, isPending } = usePutAnomaly(projectId);
  const { t } = usePluginTranslation();

  const methods = useForm<AnomalyFormSchema>({
    resolver: zodResolver(anomalyFormSchema),
    mode: 'onSubmit',
    defaultValues: {
      anomalySchema: {
        assignedTo: '',
        ...anomaly,
      },
    },
  });

  const { isDirty, isValid } = methods.formState;

  const canSubmit = !isPending && isDirty && isValid;

  const { handleSubmit } = methods;

  const onSubmit = (data: AnomalyFormSchema) => {
    datadogRum.addAction('tvp.anomaly.form.update');

    const updatedAnomaly: RequestPutAnomaly = {
      ...anomaly,
      ...data.anomalySchema,
      createAnomalyViewPointCommand: {
        ...anomaly.anomalyViewPointDto,
      },
    };

    putAnomaly(updatedAnomaly);
  };

  return (
    <Box sx={{
      py: 2,
    }}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <AnomalyForm
            buttonLabel={t('anomaly_plugin.widget.form.submit.update.label')}
            snapshot={anomaly.snapshot}
            canSubmit={canSubmit}
          />
        </form>
      </FormProvider>
    </Box>
  );
};
